import { TaskFilters } from "../types";

/**
 * Query key factory for task-related queries
 * Centralizes query key management to prevent duplication
 */
export const taskQueryKeys = {
  all: ["task-list"] as const,
  lists: () => [...taskQueryKeys.all, "list"] as const,
  list: (filters: TaskFilters, page: number, pageSize: number) =>
    [
      ...taskQueryKeys.lists(),
      filters.userList,
      filters.status,
      filters.pivLevel1,
      filters.surveys,
      page,
      pageSize,
    ] as const,
  details: () => [...taskQueryKeys.all, "detail"] as const,
  detail: (id: number) => [...taskQueryKeys.details(), id] as const,
  users: (projectId: string | undefined) => ["project-users", projectId] as const,
};

